import { AppModule as Base } from "@egr/wcf/modules/core";
export class AppModule extends Base {
    constructor(pRoomManager) {
        super();
        this.mRoomManager = pRoomManager;
    }
    get moduleId() {
        return (AppModule.MODULE_KEY);
    }
    clearDocumentData() {
        this.mRoomManager._clear();
    }
}
AppModule.MODULE_KEY = "egr.wcf.room";
